module.exports = __WEBPACK_EXTERNAL_MODULE__aws_amplify_ui__;